export const APPLICANT_TYPES = [
  { value: 'EE_ONLY', text: 'Employee Only' },
  { value: 'EE_DEPS', text: 'Employee + Spouse/Child' },
  { value: 'SP_ONLY', text: 'Spouse Only' }
]

